import { Button, ButtonProps } from "@mui/material";
import { useFormikContext } from "formik";

export interface SubmitButtonProps extends ButtonProps {}

export const SubmitButton = (props: SubmitButtonProps) => {
  const formik = useFormikContext();
  return (
    <Button
      disableRipple
      variant="contained"
      color="secondary"
      disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
      onClick={() => {
        formik.submitForm();
      }}
      {...props}>
      {props.children ?? "Submit"}
    </Button>
  );
};
